export interface SitePhotoDto {
    id: number;
    siteId: number;
    fileName: string;
    description?: string;
    category?: string;
    uploadedAt: string;
    uploadedById: number;
    uploadedByName: string;
    fileSizeInBytes: number;
    contentType: string;
}

export interface UpdateSitePhotoRequest {
    description?: string;
    category?: string;
}

export interface SitePhotoCategoryCounts {
    [category: string]: number;
}

export interface PhotoUploadRequest {
    file: File;
    category?: string;
    description?: string;
}

export const PHOTO_CATEGORIES = [
    'installation',
    'maintenance', 
    'troubleshooting',
    'uncategorized'
] as const;

export type PhotoCategory = typeof PHOTO_CATEGORIES[number];

export const PHOTO_CATEGORY_LABELS: Record<PhotoCategory, string> = {
    installation: 'Installation',
    maintenance: 'Maintenance',
    troubleshooting: 'Troubleshooting',
    uncategorized: 'Uncategorized'
}; 